import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiKentimataDoubleYpsili';
const args = {};

export class PetastiKentimataDoubleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
